<template>
  <div>
    <h1 class="headline">{{ headerText }}</h1>
    <p>{{ snippet }}</p>

    <ul class="App-list-review mdl-list">
      <review-list-item :hide-change-links="true" icon="home" route="ownership">
        <span slot="label">{{ ownershipLabel }}</span>
        <span slot="content">{{ ownershipAnswer }}</span>
      </review-list-item>

      <review-list-item
        :hide-change-links="hideChangeLinks"
        v-if="shouldAskIsResident"
        icon="airline_seat_individual_suite"
        route="isresident"
      >
        <span slot="label">{{ residentLabel }}</span>
        <span slot="content">{{ isResidentAnswer }}</span>
      </review-list-item>

      <!-- Render out the custom questions -->
      <review-questions
        :hide-change-links="hideChangeLinks"
        :questions="questions"
        :is-resident="isResidentAnswer"
      ></review-questions>

      <review-list-item
        :hide-change-links="hideChangeLinks"
        icon="record_voice_over"
        route="proxy"
        v-if="shouldShowProxyHolder"
      >
        <span slot="label">{{ proxyLabel }}</span>
        <span slot="content">{{ proxyAnswer }}</span>
      </review-list-item>

      <review-list-item
        :hide-change-links="hideChangeLinks"
        icon="chat"
        route="comms"
        v-if="shouldShowComms"
      >
        <span slot="label">{{ commsLabel }}</span>
        <span slot="content">{{ commsAnswer }}</span>
      </review-list-item>
    </ul>

    <div class="App-buttons">
      <review-buttons
        :is-disabled="false"
        :is-abstain="isAbstain"
        @show-abstain-modal="showModal = true"
      />
    </div>

    <!-- modal popup when all voting matters are abstained -->
    <review-modal
      v-show="showModal"
      @accept-review-modal="acceptReviewModal"
      @close-modal="resetModal"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import ButtonComponent from '@/components/Button.vue';
import ReviewButtons from './ReviewButtons';
import ReviewListItem from './ReviewListItem.vue';
import ReviewQuestions from './ReviewQuestions.vue';
import ReviewModal from './ReviewModal.vue';

import {mapGetters, mapActions} from 'vuex';
import {checkAbstain} from '@/vuex/helpers.js';

export default {
  components: {
    ButtonComponent,
    ReviewButtons,
    ReviewListItem,
    ReviewQuestions,
    ReviewModal
  },
  computed: {
    ...mapGetters({
      comms: 'comms/comms',
      contact: 'contact/contact',
      displayOptions: 'displayOptions',
      meeting: 'meeting/meeting',
      isResident: 'resident/isResident',
      ownership: 'ownership/ownership',
      proxyHolder: 'proxy/proxyHolder',
      proxyDropdownSelection: 'proxy/proxyDropdownSelection',
      questions: 'questions/questions',
      shouldAskIsResident: 'resident/shouldAskIsResident'
    }),
    ownershipAnswer() {
      return `${this.ownership.unit} - ${this.ownership.address}`;
    },
    isResidentAnswer() {
      return this.isResident === 'yes' ? 'Yes' : 'No';
    },
    proxyAnswer() {
      // append dropdown selection to proxy holder's name, if dropdown selection exists
      if (this.proxyDropdownSelection) {
        return this.proxyHolder.name === 'default'
          ? this.meeting.defaultHolder + ', ' + this.proxyDropdownSelection
          : this.proxyHolder.name + ', ' + this.proxyDropdownSelection;
      } else {
        return this.proxyHolder.name === 'default'
          ? this.meeting.defaultHolder
          : this.proxyHolder.name;
      }
    },
    contactInfo() {
      return `${this.contact.name}, ${this.contact.email}`;
    },
    commsAnswer() {
      if (this.comms === 'yes') {
        return 'Yes, I consent to receiving all notices electronically';
      }
      return 'I don`t consent to electronic notices';
    },
    shouldShowProxyHolder() {
      return !this.meeting.options.disable_proxy_holder;
    },
    shouldShowComms() {
      let disableComms = _.get(this.meeting, 'options.disable_comms', false);
      let consentStatus = _.get(this.meeting, 'voter.consent.status', false);
      let email = _.get(this.meeting, 'voter.email', '');

      if (
        disableComms ||
        consentStatus === 'consented' ||
        email === 'noemail@getquorum.com'
      ) {
        return false;
      }
      return true;
    },
    isAbstain() {
      if (_.get(this.meeting, 'options.allow_no_instructions', false)) {
        return checkAbstain(this.questions, this.isResidentAnswer);
      } else {
        return false;
      }
    },
    hideChangeLinks() {
      return _.get(
        this.meeting,
        'options.proxy_app_display_options.review.hide_change_links',
        false
      );
    }
  },
  data() {
    return {
      headerText: 'Review Your Answers',
      snippet: 'Please review your answers before moving on to the final step.',
      ownershipLabel: 'You are the owner / mortgagee of...',
      contactLabel: 'Your contact info is...',
      residentLabel: 'Do you live in this suite?',
      proxyLabel: 'Your appointed proxy holder is...',
      commsLabel: 'Your communications preferences...',
      showModal: false
    };
  },
  methods: {
    ...mapActions('proxy', ['setProxyAbstainOption']),
    resetModal() {
      // Reset the abstain option selected
      this.setProxyAbstainOption('');
      this.showModal = false;
    },
    acceptReviewModal() {
      this.setProxyAbstainOption('abstain-all');
    },
    setCustomText() {
      if (!_.has(this.displayOptions, 'review')) {
        return;
      }
      const {review} = this.displayOptions;
      this.headerText = review.header_text || this.headerText;
      this.ownershipLabel = review.ownership_label_text || this.ownershipLabel;
      this.contactLabel = review.contact_label_text || this.contactLabel;
      this.residentLabel = review.resident_label_text || this.residentLabel;
      this.proxyLabel = review.proxy_label_text || this.proxyLabel;
      this.commsLabel = review.comms_label_text || this.commsLabel;
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.setCustomText();
      componentHandler.upgradeAllRegistered();
    });
  }
};
</script>

<style scoped>
.App-list-review {
  border-radius: 4px;
}

.App-review__acknowledgement {
  padding-bottom: 2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Review/Review.vue